import React from 'react';

import './checkbox-group.scss';

interface CheckboxGroupProps {
  children: React.ReactNode;
  groupTitle: string;
}

function CheckboxGroup(props: CheckboxGroupProps) {
  const { children, groupTitle } = props;

  return (
    <div styleName="container">
      <fieldset>
        <legend>{groupTitle}</legend>
        {children}
      </fieldset>
    </div>
  );
}

export default CheckboxGroup;
